// Globals
import { ColumnsType } from 'antd/es/table';
import { TFunction } from 'react-i18next';

// Models
import { IFullAddress } from '@/models/addresses.model';
import { IOrder } from '@/models/order.model';
import { ROUTES } from '@/models/router.model';

// Components
import { StyledLink, StyledStep, StyledTag } from '../components/Styled';

// Helpers
import { formatDate, getEntityId } from '@/utils';

type TGetOrdersTableColumns = {
  t: TFunction;
};

export const getOrdersTableColumns = ({ t }: TGetOrdersTableColumns): ColumnsType<IOrder> => [
  {
    title: t('tripletex_id'),
    dataIndex: 'tripletex_order_number',
    key: 'tripletex_order_number',
    width: 200,
    render: (id) => <StyledStep>{id}</StyledStep>,
  },
  {
    title: t('order_type'),
    dataIndex: 'step_name',
    key: 'step_name',
    width: 250,
    render: (stepName) => <StyledStep>{t(stepName)}</StyledStep>,
  },
  {
    title: t('order_address'),
    dataIndex: 'property_address',
    key: 'property_address',
    render: (address: IFullAddress) => <span>{address?.full_address}</span>,
  },
  {
    title: t('order_date'),
    dataIndex: 'created',
    key: 'created',
    render: (created) => <span>{formatDate(created)}</span>,
  },
  {
    title: t('user'),
    dataIndex: 'user_name',
    key: 'user_name',
    width: 250,
    render: (user: string, record) => (
      <StyledLink
        path={{
          pathname: `${ROUTES.USERS}`,
          search: new URLSearchParams({ id: getEntityId(record.user_id) }).toString(),
        }}
        target="_blank"
        onClick={(e) => e.stopPropagation()}
      >
        {user}
      </StyledLink>
    ),
  },

  {
    title: t('payment_method'),
    dataIndex: 'payment_instrument',
    key: 'payment_instrument',
    width: 200,
    render: (payment_instrument) => <span>{payment_instrument ? t(`payment_method_${payment_instrument}`) : '-'}</span>,
  },
  {
    title: t('payment_status'),
    dataIndex: 'payment_status',
    key: 'payment_status',
    width: 200,
    render: (payment_status) => <span>{payment_status ? t(`payment_status_${payment_status}`) : '-'}</span>,
  },
  {
    title: t('status'),
    dataIndex: 'status',
    key: 'status',
    width: 200,
    render: (status) => <StyledTag $status={status}>{t(`status_${status}`)}</StyledTag>,
  },
];
